<template>
    <div class="cz2__ai-modal__error">
        <div>
            <div class="cz2__modal-popup__super-header">
                {{ errorSuper }}
            </div>

            <div
                v-html="errorHeading"
                class="cz2__modal-popup__header"
            />
        </div>

        <p class="cz2__modal-popup__copy cz2__modal-popup__copy--ai-centered">
            {{ errorCopy }}
        </p>

        <div class="cz2__ai-modal__buttons">
            <selfie-button :is-error-state="isSelfieErrorState" />
            <upload-button />
            <build-button />
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__error {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
            }

            .cz2__modal-popup__copy--ai-centered {
                text-align: center;
            }
        }
    }
</style>

<script>
    import SelfieButton from './SelfieButton.vue';
    import UploadButton from './UploadButton.vue';
    import BuildButton from './BuildButton.vue';

    export default {
        components: {
            SelfieButton,
            UploadButton,
            BuildButton,
        },

        data() {
            return {
                errorSuper: '',
                errorHeading: '',
                errorCopy: '',
            };
        },

        computed: {
            aiActiveState() {
                return this.$store.state.aiActiveState;
            },

            aiStates() {
                return this.$store.state.aiStates;
            },

            isSelfieErrorState() {
                return this.aiActiveState === this.aiStates.selfie;
            },

            aiMatchError() {
                return this.$store.state.customizer.aiMatchError;
            },
        },

        mounted() {
            this.getErrorCopy();
        },

        methods: {
            getErrorCopy() {
                if (this.aiMatchError === 'no-person') {
                    if (this.isSelfieErrorState) {
                        this.errorSuper = this.$t('AI_ERROR_NO_PERSON_SELFIE_SUPER');
                        this.errorHeading = this.$t('AI_ERROR_NO_PERSON_SELFIE_HEADING');
                        this.errorCopy = this.$t('AI_ERROR_NO_PERSON_SELFIE_COPY');
                    } else {
                        this.errorSuper = this.$t('AI_ERROR_NO_PERSON_UPLOAD_SUPER');
                        this.errorHeading = this.$t('AI_ERROR_NO_PERSON_UPLOAD_HEADING');
                        this.errorCopy = this.$t('AI_ERROR_NO_PERSON_UPLOAD_COPY');
                    }
                } else if (this.aiMatchError === 'file-type') {
                    this.errorSuper = this.$t('AI_ERROR_FILE_TYPE_SUPER');
                    this.errorHeading = this.$t('AI_ERROR_FILE_TYPE_HEADING');
                    this.errorCopy = this.$t('AI_ERROR_FILE_TYPE_COPY');
                } else if (this.aiMatchError === 'file-size') {
                    this.errorSuper = this.$t('AI_ERROR_FILE_SIZE_SUPER');
                    this.errorHeading = this.$t('AI_ERROR_FILE_SIZE_HEADING');
                    this.errorCopy = this.$t('AI_ERROR_FILE_SIZE_COPY');
                } else {
                    this.errorSuper = this.$t('AI_ERROR_GENERIC_SUPER');
                    this.errorHeading = this.$t('AI_ERROR_GENERIC_HEADING');
                    this.errorCopy = this.$t('AI_ERROR_GENERIC_COPY');
                }
            },
        },
    };
</script>
